import useTranslations from "hooks/useTranslations"

export const Label = ({ label, required = false, error = false }) => {
  const { formRequired } = useTranslations()
  return (
    <div className="mb-1 flex justify-between">
      <div className="text-sm">
        <label className="font-bold text-zinc-700 ">{label}</label>
        {required && <span className="ml-1 text-red-500">*</span>}
      </div>
      {error && (
        <div className="ml-1 text-sm text-red-500 ">{formRequired}</div>
      )}
    </div>
  )
}
